import { SEMANTIC_BUTTON_PROPS, SEMANTIC_GRID_COLUMN_PROPS, SEMANTIC_MENU_PROPS, SEMANTIC_MENU_ITEM_PROPS, SEMANTIC_ACCORDION_PROPS, SEMANTIC_ACCORDION_CONTENT_PROPS, SEMANTIC_CARD_PROPS, SEMANTIC_CARD_CONTENT_PROPS, SEMANTIC_ICON_PROPS, SEMANTIC_ACCORDION_TITLE_PROPS, SEMANTIC_MODAL_PROPS, SEMANTIC_TRANSITIONABLE_PORTAL_PROPS, SEMANTIC_CONTAINER_PROPS, HEADER_PROPS, SEMANTIC_GRID_PROPS } from './use-semantic-ui-props.constants';
import { getValidProps } from '../../services/props';
export default function useSemanticUiProps() {
  function getButtonProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_BUTTON_PROPS);
  }
  function getGridProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_GRID_PROPS);
  }
  function getColumnProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_GRID_COLUMN_PROPS);
  }
  function getMenuProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_MENU_PROPS);
  }
  function getMenuItemProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_MENU_ITEM_PROPS);
  }
  function getAccordionProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_ACCORDION_PROPS);
  }
  function getAccordionContentProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_ACCORDION_CONTENT_PROPS);
  }
  function getAccordionTitleProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_ACCORDION_TITLE_PROPS);
  }
  function getCardProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_CARD_PROPS);
  }
  function getCardContentProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_CARD_CONTENT_PROPS);
  }
  function getIconProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_ICON_PROPS);
  }
  function getModalProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_MODAL_PROPS);
  }
  function getTransitionablePortalProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_TRANSITIONABLE_PORTAL_PROPS);
  }
  function getContainerProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, SEMANTIC_CONTAINER_PROPS);
  }
  function getHeaderProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getValidProps(props, HEADER_PROPS);
  }
  return {
    getButtonProps: getButtonProps,
    getMenuProps: getMenuProps,
    getMenuItemProps: getMenuItemProps,
    getColumnProps: getColumnProps,
    getAccordionProps: getAccordionProps,
    getAccordionContentProps: getAccordionContentProps,
    getCardProps: getCardProps,
    getCardContentProps: getCardContentProps,
    getIconProps: getIconProps,
    getAccordionTitleProps: getAccordionTitleProps,
    getModalProps: getModalProps,
    getTransitionablePortalProps: getTransitionablePortalProps,
    getContainerProps: getContainerProps,
    getHeaderProps: getHeaderProps,
    getGridProps: getGridProps
  };
}